module.exports = __webpack_public_path__ + "static/img/logo.efb76829.svg";